export default "__VITE_ASSET__lV_5syyE__"